import {
  ElementObserver,   // Use this to observe when an element enters and exits the viewport
  // PositionObserver,   // Use this to observe when a viewport reaches its bounds
  // ObserverCollection // Advanced: Used for grouping custom viewport handling
} from 'viewprt'
// https://github.com/gpoitch/viewprt

window.ElementObserver = ElementObserver

// export default function () {
export function initArrows() {
  // console.log('run arrows');
  // document.addEventListener('DOMContentLoaded', () => {

    // no-smooth-scroll
    document.querySelectorAll('.b-main-triple__pic-num').forEach( el => {
      el.addEventListener("click", () => {
        document.querySelector('html').classList.add('no-smooth-scroll')
        setTimeout(() => {
          document.querySelector('html').classList.remove('no-smooth-scroll')
        }, 500);
      }, false);
    } )

    var elementInBodyObserver1 = ElementObserver(document.querySelector('.b-main-triple__step--fake-1'), {
      onEnter: onEnter,
      onExit: onExit,
      offsetY: -window.innerHeight/2
    })
    // elementInBodyObserver1.activate()

    var elementInBodyObserver2 = ElementObserver(document.querySelector('.b-main-triple__step--fake-2'), {
      onEnter: onEnter,
      onExit: onExit,
      offsetY: -window.innerHeight/2
    })
    // elementInBodyObserver2.activate()

    var elementInBodyObserver3 = ElementObserver(document.querySelector('.b-main-triple__step--fake-3'), {
      onEnter: onEnter,
      onExit: onExit,
      offsetY: -window.innerHeight/2
    })
    // elementInBodyObserver3.activate()

    function onEnter(element, viewportState) {
      // element.style.backgroundColor = 'green'
      element.classList.add('target-in-view');
      let rel = element.getAttribute('rel')
      document.querySelector(`.b-main-triple__step--${rel}`).classList.add('b-main-triple__step-content--active')
      document.querySelector(`.b-main-triple__pic-arrows`).classList.add(`b-main-triple__pic-arrows--${rel}`)
      document.querySelector(`.b-main-triple__pic-num--${rel}`).classList.add(`b-main-triple__pic-num--active`)
      // console.log('viewportState', viewportState);
      // if (rel == 1 && viewportState.directionY == 'down') {
      //   document.querySelector('html').classList.add('___________________fix')
      // }
      // if (rel == 3 && viewportState.directionY == 'up') {
      //   document.querySelector('html').classList.add('___________________fix')
      // }
    }
    function onExit(element, viewportState) {
      // element.style.backgroundColor = 'blue'
      element.classList.remove('target-in-view');
      let rel = element.getAttribute('rel')
      document.querySelector(`.b-main-triple__step--${rel}`).classList.remove('b-main-triple__step-content--active')
      document.querySelector(`.b-main-triple__pic-arrows`).classList.remove(`b-main-triple__pic-arrows--${rel}`)
      document.querySelector(`.b-main-triple__pic-num--${rel}`).classList.remove(`b-main-triple__pic-num--active`)
      // if (rel == 3 && viewportState.directionY == 'down') {
      //   document.querySelector('html').classList.remove('___________________fix')
      // }
      // if (rel == 1 && viewportState.directionY == 'up') {
      //   document.querySelector('html').classList.remove('___________________fix')
      // }
    }

  // })

}